import React, { useContext, useEffect, useRef, useState } from 'react'
import { themeContext } from 'global/context/sub-contexts/themeContext'
import BreakShareButton from 'steps/shared/BreakShareButton'
import AwesomeDebouncePromise from 'awesome-debounce-promise'
import ShareIcons from 'components/ShareIcons'
import { getStepLabel } from 'components/NavBar/utils/getStepLabel'
import { i18next } from 'i18n'
import analytics from 'global/AnalyticsData'
import './SideNav.scss'

//Filters global break options from complete step for sponsored break sidenav.
//returns false if no options at all. returns object with social share properties if there are any.
const getGlobalBreakShareProps = brk => {
  let defaultProps = {
    shareCopy: false,
    pinterestShare: false,
    emailShare: false,
    copyShare: false,
    whatsappShare: false,
    facebookShare: false,
    twitterShare: false,
  }
  let ret = false
  try {
    const stepz = brk.steps
    let cStep = stepz.filter(function (step) {
      return step.type === 'COMPLETE' ? true : false
    })[0]
    if (cStep && cStep.socialShareOn) {
      for (const prop in defaultProps) {
        if (cStep.hasOwnProperty(prop) && cStep[prop] === true) {
          defaultProps[prop] = true
          ret = true
        }
      }
      if (ret === true) {
        ret = defaultProps
      }
    }
  } catch (e) {
    console.log(`error doing global social math: ${e}`)
  }
  return ret
}

const SideNav = ({
  stepStatusStr,
  activeStepPosition,
  onItemClicked,
  brk,
  mobile,
}) => {
  const [sidenavActive, setSidenavActive] = useState(true)
  const sideBarRef = useRef(null)
  const stepStatusArr = JSON.parse(stepStatusStr)
  const brkPlatform = brk.platform || 'DAILYBREAK'
  const socialProps = getGlobalBreakShareProps(brk) //Inelegant method of filtering global share break props
  const handleGlobalShareClick = ({ platform, link }) => {
    analytics.trackEvent('global_break_share_social_click', {
      platform: brkPlatform,
      result: platform,
      result_id: platform,
      link: link,
    })
  }
  // show the sidebar when the break loads, then hide it a few seconds later
  useEffect(() => {
    //To avoid initial load pop-in, we populate "show" in dom
    //sideBarRef.current.classList.add("show")
    const timer = setTimeout(() => {
      if (sidenavActive) {
        setSidenavActive(false)
      }
    }, 3500)
    return () => clearTimeout(timer)
  }, [])

  // eslint-disable-line no-unused-vars

  let colors = useContext(themeContext)
  let barStyle = {}

  if (colors && colors.styles._mission) {
    barStyle['backgroundColor'] = colors.styles._mission.missionColor1
    // not sure about this. the default is RGBA to provide opacity.
    // value from beaker is just a hex code
    //   lockedStyle['backgroundColor'] = colors.styles._mission.missionColor3
  }

  const toggleSidebar = async function (e) {
    if (e.type === 'mouseover' || e.type === 'focus') {
      setSidenavActive(true)
    } else {
      setSidenavActive(false)
    }
  }

  const toggleSidebarDebounced = AwesomeDebouncePromise(toggleSidebar, 200)

  return (
    <div
      className={`steps-progress-bar ${sidenavActive ? `show` : `hide`} ${
        mobile && 'mobile'
      }`}
      onFocus={toggleSidebarDebounced}
      onBlur={toggleSidebarDebounced}
      onMouseOver={toggleSidebarDebounced}
      onMouseOut={toggleSidebarDebounced}
      ref={sideBarRef}
    >
      {/* Declares the language of these labels so `hyphens: auto` can break a long
          word on syllables. Without it the browser has no dictionary to use and a
          word like ROMPECABEZAS breaks at an arbitrary point. */}
      <nav className="step-list" lang={i18next.language}>
        <ul>
          {stepStatusArr &&
            stepStatusArr.map((stepStatus, i) => {
              return (
                <li
                  key={i}
                  tabIndex={0}
                  className={`nav-item nav-item${i}
                                  ${stepStatus.locked ? 'locked' : 'unlocked'}
                                  ${stepStatus.complete ? 'completed' : 'todo'}
                                  ${
                                    stepStatus.position ===
                                    parseInt(activeStepPosition)
                                      ? 'active'
                                      : ''
                                  }
                              `}
                  onClick={e => {
                    analytics.breakEvent('menu_navigation_click', brk, {
                      context: activeStepPosition,
                      result: i,
                      context_total: stepStatusArr.length,
                      context_position: activeStepPosition,
                    })
                    onItemClicked &&
                      onItemClicked({
                        stepId: stepStatus.id,
                        position: i,
                        isLocked: stepStatus.locked,
                        isAlreadyTaken: stepStatus.complete,
                      })
                  }}
                  onKeyUp={e => {
                    if (e.key === 'Enter') {
                      analytics.breakEvent('menu_navigation_click', brk, {
                        context: activeStepPosition,
                        result: i,
                        context_total: stepStatusArr.length,
                        context_position: activeStepPosition,
                      })
                      onItemClicked &&
                        onItemClicked({
                          stepId: stepStatus.id,
                          position: i,
                          isLocked: stepStatus.locked,
                          isAlreadyTaken: stepStatus.complete,
                        })
                    }
                  }}
                  dangerouslySetInnerHTML={{
                    __html: getStepLabel({
                      label: stepStatus.label,
                      stepType: stepStatus.type,
                    }),
                  }}
                />
              )
            })}
        </ul>
        {typeof socialProps === `object` && (
          <BreakShareButton sidenavActive={sidenavActive}>
            <ShareIcons
              onShareClick={handleGlobalShareClick}
              shareUrl={brk.shareUrl}
              {...socialProps}
            />
          </BreakShareButton>
        )}
      </nav>
    </div>
  )
}

export default SideNav
